// Simple localStorage wrapper for training sessions
const STORAGE_KEY = 'martialArts_trainingSession';

export const sessionStorage = {
  save: (sessionData) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        ...sessionData,
        lastSaved: Date.now()
      }));
    } catch (error) {
      console.error('Failed to save session data:', error);
    }
  },

  load: () => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Failed to load session data:', error);
      return null;
    }
  },

  clear: () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('Failed to clear session data:', error);
    }
  },

  hasRecoverableSession: () => {
    try {
      const data = sessionStorage.load();
      if (!data) return false;
      
      // Check if session is too old (older than 24 hours = not recoverable)
      const maxAge = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
      const age = Date.now() - (data.lastSaved || 0);
      
      return age < maxAge;
    } catch (error) {
      console.error('Failed to check recoverable session:', error);
      return false;
    }
  }
};
